import { LoadingSpinner } from '@expressable/syntax-ds';
import { captureException } from '@sentry/react';
import { useCognitoUserContext, useCognitoUserContextWithUser } from 'domains/auth/AWSCognitoWrapper/context';
import { useContactById } from 'domains/contact/hooks';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { SignupError } from 'utils/errors/debuggableError';

export const SignupContactGate = () => {
  const cognito = useCognitoUserContext();

  if (cognito.isLoggedIn && cognito.user) return <ContactGate />;

  return <Outlet />;
};

const ContactGate = () => {
  const { user, signOut } = useCognitoUserContextWithUser();

  const onError = useCallback(
    (err: unknown) => {
      signOut();
      captureException(
        new SignupError(`Unable to load contact data for contact ID ${user.username}`, {
          debugData: {
            err,
            user,
          },
        }),
      );
    },
    [signOut, user],
  );

  const { isLoading } = useContactById({ contactId: user.username, onError });

  const { t } = useTranslation();

  if (isLoading) return <LoadingSpinner message={t('directSignup.loading')} className="self-center" />;

  return <Outlet />;
};
